export const toCyrillicMap: {[char: string]: string} = {
  a: 'а',
  b: 'б',
  v: 'в',
  g: 'г',
  d: 'д',
  e: 'е',
  jo: 'ё',
  yo: 'ё',
  ö: 'ё',
  zh: 'ж',
  z: 'з',
  i: 'и',
  j: 'й',
  k: 'к',
  l: 'л',
  m: 'м',
  n: 'н',
  o: 'о',
  p: 'п',
  r: 'р',
  s: 'с',
  t: 'т',
  u: 'у',
  f: 'ф',
  kh: 'х',
  h: 'х',
  x: 'кс',
  c: 'ц',
  ch: 'ч',
  sh: 'ш',
  shh: 'щ',
  shch: 'щ',
  w: 'щ',
  "''": 'ъ',
  y: 'ы',
  "'": 'ь',
  je: 'э',
  ä: 'э',
  ju: 'ю',
  yu: 'ю',
  ü: 'ю',
  ja: 'я',
  ya: 'я',
  q: 'я'
}

export const toLatinMap: {[char: string]: string | string[]} = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: ['yo', 'jo', 'ö'],
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'j',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: ['kh', 'h'],
  ц: ['ts', 'c'],
  ч: 'ch',
  ш: 'sh',
  щ: ['shh', 'shch', 'w'],
  ъ: "''",
  ы: 'y',
  ь: "'",
  э: ['е', 'je'],
  ю: ['yu', 'ju', 'ü'],
  я: ['ya', 'ja', 'q']
}

export const toCyrillicKeyboardMap: {[char: string]: string} = {
  q: 'й',
  w: 'ц',
  e: 'у',
  r: 'к',
  t: 'е',
  y: 'н',
  u: 'г',
  i: 'ш',
  o: 'щ',
  p: 'з',
  '[': 'х',
  ']': 'ъ',

  a: 'ф',
  s: 'ы',
  d: 'в',
  f: 'а',
  g: 'п',
  h: 'р',
  j: 'о',
  k: 'л',
  l: 'д',
  ';': 'ж',
  "'": 'э',
  '\\': 'ё',

  z: 'я',
  x: 'ч',
  c: 'с',
  v: 'м',
  b: 'и',
  n: 'т',
  m: 'ь',
  ',': 'б',
  '.': 'ю'
}

export const toLatinKeyboardMap: {[char: string]: string} = {
  й: 'q',
  ц: 'w',
  у: 'e',
  к: 'r',
  е: 't',
  н: 'y',
  г: 'u',
  ш: 'i',
  щ: 'o',
  з: 'p',

  ф: 'a',
  ы: 's',
  в: 'd',
  а: 'f',
  п: 'g',
  р: 'h',
  о: 'j',
  л: 'k',
  д: 'l',

  я: 'z',
  ч: 'x',
  с: 'c',
  м: 'v',
  и: 'b',
  т: 'n',
  ь: 'm'
}
